import {request} from "./requests";

export async function isValid(inviteCode){
    let r = await request({
        url: `/ivc/c/${inviteCode}`,
        method: 'get'
    });
    return r;
}



// WEBPACK FOOTER //
// ./src/data/invitecode.js